import React, {
  useState,
  useEffect,
  useCallback,
  Fragment,
  useContext,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Numeral from "../../../components/numeral/Numeral";
import { Primary } from "../../../components/buttons/Primary";
import {
  ArrowLongRightIcon,
  ArrowTrendingUpIcon,
} from "@heroicons/react/24/outline";
import { HttpRequest } from "../../../services/httpRequest";
import { SkeletonDahsboard } from "../../../components/skeleton/skeletonDash";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { SecondaryCard } from "../../../components/buttons/SecondaryCard";
import { useCredit } from "../../../context/creditContext";
import { creditStatus } from "../../flujo/Utils";
import { RewardsViewContext } from "../../../context/Disclosures/rewards/rewardsContext";
import { CreditUserContext } from "../../../context/CreditUser/CreditUserContext";
import moment from "moment";
import { Spinner } from "../../../components/spinner/spinner_await";
import { SuccessAlert } from "../../../components/alerts/successAlert";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { useMobileDetection } from "../../../hooks/use-mobile-detection";
import { InfoAlert } from "../../../components/alerts/infoAlert";
import { CreditStatusEnum } from "../../../constants/CreditStatusEnum";
import { getStoredUtmReferral } from "../../../services/utmleads/utmReferral";
import { useUtmTracking } from "../../../hooks/useUtmTracking";

export function RenovarPage() {
  useUtmTracking();
  const { updateRewardsView } = useContext(RewardsViewContext);
  const navigate = useNavigate();
  useLocation();
  const { disclosures, creditInfo, due } = useCredit();
  const [cupoDisponible, setCupoDisponible] = useState("");
  const [, setCupoAprobado] = useState("");
  const [, setCupoUtilizado] = useState("");
  const [creditsInfo, setCreditsInfo] = useState({});
  const [basicInfo, setBasicInfo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [costs, setCosts] = useState([]);
  const [isOpenSpinner, setIsOpenSpinner] = useState(false);
  const { creditUser, updateCreditUser } = useContext(CreditUserContext);
  const [, setViewalert] = useState(false);
  const [, setMessageModal] = useState("");
  const [, setRedirectModal] = useState("");
  const { isDesktop } = useMobileDetection();

  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);

  const loadCreditById = useCallback(async () => {
    try {
      const data = await HttpRequest.getCreditById(
        localStorage.getItem("credit_id"),
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadInfoUser = useCallback(async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const loadInfoQuota = useCallback(async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc"),
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleOpenDisclosure = () => {
    updateRewardsView({
      openDisclosure: true,
    });
  };

  const loadCreditUserPendingSignature = useCallback(async () => {
    try {
      const data = await HttpRequest.getCreditUserPendingSignature(
        localStorage.getItem("doc"),
      );
      let credit;
      if (data.message.info !== undefined) {
        credit = data.message.info;
      } else {
        return loadCreditById();
      }
      return credit;
    } catch (error) {
      console.log(error);
    }
  }, [loadCreditById]);

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    const loadQuotaStatus = async () => {
      let quotaStatus = await loadInfoQuota();
      return quotaStatus;
    };

    const _loadCreditById = async () => {
      let credit = await loadCreditUserPendingSignature();
      return credit;
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          try {
            let cupo = await loadQuotaStatus();
            let creditInfo = await _loadCreditById();
            if (!creditInfo) {
              return navigate("/request-credit");
            } else {
              if (
                creditInfo?.status === creditStatus.PF ||
                creditInfo?.status === creditStatus.S
              ) {
                if (creditInfo.customer === "Nuevo") {
                  return navigate(
                    `/request-credit?statusCredit=${creditInfo.status}&credit_id=${creditInfo.credit_id}`,
                  );
                }
                // handleOpenAlert(
                //   "info",
                //   `Ya tienes un crédito pendiente por firmar`,
                //   true,
                // );
                // setTimeout(() => {
                //   return navigate("/oferta");
                // }, 3000);
              }
            }

            setCreditsInfo(creditInfo);
            setCupoDisponible(cupo?.cupoDisponible);
            setCupoAprobado(cupo?.cupoAprobado);
            setCupoUtilizado(cupo?.cupoUtilizado);
            let infoUser = await loadInfo();
            setBasicInfo(infoUser);
            let costs = [
              { item: "Cupo aprobado", value: cupo?.cupoAprobado ?? 0 },
              {
                item: "Deuda a la fecha",
                value:
                  creditInfo?.status !== "Vigente"
                    ? 0
                    : (creditInfo?.paymentBalance ?? 0),
              },
            ];
            setCosts(costs);
            setIsLoading(false);
          } catch (error) {
            console.log(error);
            return;
          }
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, [navigate, loadInfoUser, loadInfoQuota, loadCreditUserPendingSignature]);

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "info") {
      setMessageAlert(message);
      setAlertSession(isOpen);
      setIsOpenInfo(isOpen);
    }

    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessageModal("");
    handleClearStateAlert();
    try {
      let creditData = { ...creditUser };
      creditData.versionTarifas = "2";
      creditData.requestedAmount = cupoDisponible;
      creditData.approvedQuota = cupoDisponible;
      creditData.versionContrato = "2";
      creditData.status = "Solicitado";
      creditData.approvedDate = moment().format("DD/MM/YYYY");
      creditData.documento = localStorage.getItem("doc");
      creditData.acceptanceDate = moment().format("DD/MM/YYYY");
      updateCreditUser(creditData);
      let payload = {
        creditInfo: creditData,
        doc: localStorage.getItem("doc"),
        lastPartnerReferral: getStoredUtmReferral(),
      };
      //console.log("lo que se envia para solicitar renovacion: ", creditUser);
      let response = await HttpRequest.renovarCredito(payload);
      await HttpRequest.registrarFechaAceptacion({
        credit_id: response.message.message.credit_id,
        acceptanceDate: moment().format("DD/MM/YYYY"),
        documento: creditData.documento,
      });

      if (response.error && response.message?.code === "INVALIDQUOTA") {
        setIsOpenSpinner(false);
        handleOpenAlert(
          "error",
          `Lo sentimos. 
          no podemos procesar tu solicitud, hay un aumento inusual en tu cupo, por favor comunicate con el área de soporte para
          revisar a fondo, gracias por tu comprensión.`,
          true,
        );
        return;
      }

      if (response.message.error === true) {
        handleOpenAlert(
          "error",
          "Ha ocurrido un error interno, por favor intente mas tarde.",
          true,
        );
        setIsOpenSpinner(false);
        return;
      }

      setIsOpenSpinner(false);

      if (response.message.statusCredit === "APROBADO") {
        let credit_id = response.message.message?.credit_id;
        localStorage.setItem("credit_id", credit_id);
        updateCreditUser({
          ...creditUser,
          credit_id: credit_id,
          approvedQuota: cupoDisponible,
          documento: localStorage.getItem("doc"),
          acceptanceDate: moment().format("DD/MM/YYYY"),
          approvedDate: moment().format("DD/MM/YYYY"),
          status: "Solicitado",
          versionTarifas: "2",
          versionContrato: "2",
        });
        /* return navigate(
          `/request-credit?renovar=${true}&doc=${
            state?.doc ?? localStorage.getItem("doc")
          }&credit_id=${credit_id}`
        ); */

        return navigate("/oferta", {
          state: {
            isRenovateCredit: true,
            doc: localStorage.getItem("doc"),
            credit_id: credit_id,
          },
        });
      } else if (response.message.statusCredit === "RECHAZADO") {
        if (response.message?.motivo === "TIENE CREDITO VIGENTE") {
          setMessageModal(
            "Debes pagar el crédito que tienes actualmente para poder usar tu cupo de crédito.",
          );
          setRedirectModal("/pagar");
        } else {
          handleOpenAlert(
            "error",
            "Lo sentimos, su crédito ha sido rechazado",
            true,
          );
        }
      }
    } catch (error) {
      console.log("Error :", error);
      alert("Ha ocurrido un error interno, por favor intente mas tarde.");
      return;
    }
  };

  if (isLoading) {
    return (
      <Fragment>
        <DashboardMyCredit
          name={""}
          balance={""}
          current={"3"}
          title={"Consultar cupo"}
          main={
            <>
              <div className="pt-10 mt-10 md:mt-0 pb-32 md:pb-0 bg-white md:bg-transparent rounded-t-3xl">
                <div className="md:mx-8 xl:mx-16 px-8 py-10 bg-white md:shadow-lg shadow-none rounded-2xl">
                  <div className="px-4">
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={100} />
                      <SkeletonDahsboard height={20} width={70} />
                    </div>
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={110} />
                      <SkeletonDahsboard height={20} width={70} />
                      <SkeletonDahsboard height={20} width={200} />
                      <SkeletonDahsboard height={30} width={40} />
                    </div>
                    <div className="block pt-6">
                      <SkeletonDahsboard height={20} width={100} />
                      <SkeletonDahsboard height={40} width={120} />
                    </div>
                    <div className="grid pt-6 justify-center">
                      <div className="flex gap-2 pt-8 justify-center">
                        <div className="pb-2 sm:pb-0">
                          <SkeletonDahsboard height={50} width={150} />
                        </div>
                      </div>
                      <div className="flex xl:hidden gap-2 text-sm pt-2">
                        <div className="grid justify-center w-full">
                          <div className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto">
                            <SkeletonDahsboard
                              variant={"circular"}
                              height={20}
                              width={20}
                            />
                          </div>
                          <SkeletonDahsboard height={15} width={60} />
                        </div>
                        <div className="grid justify-center w-full">
                          <div className="grid justify-center w-full">
                            <div className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto">
                              <SkeletonDahsboard
                                variant={"circular"}
                                height={20}
                                width={20}
                              />
                            </div>
                            <SkeletonDahsboard height={15} width={60} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </Fragment>
    );
  }

  return (
    <Fragment>
      {alertSession && (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></SuccessAlert>
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></ErrorAlert>
        </>
      )}

      <DashboardMyCredit
        name={basicInfo?.firstname ? basicInfo?.firstname : ""}
        current={"3"}
        balance={
          creditsInfo?.status === "Cancelado" ? 0 : creditsInfo?.paymentBalance
        }
        title={"Consultar cupo"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        main={
          <>
            <div className="pt-10 mt-10 md:mt-0 pb-32 md:pb-0 bg-white md:bg-transparent rounded-t-3xl">
              <div className="md:mx-8 xl:mx-16 px-8 py-10 bg-white md:shadow-lg shadow-none rounded-2xl">
                <div className="px-4">
                  {costs.map((cost, index) => (
                    <div key={index} className="block pt-6">
                      <span className="block text-grayP">{cost.item} </span>
                      <Numeral
                        className="text-2xl font-bold"
                        format={"$0,0"}
                        value={cost.value === 0 ? "$0" : cost.value}
                      />
                    </div>
                  ))}
                  {creditsInfo?.status && creditsInfo.status === "Vigente" ? (
                    <>
                      <div className="text-sm text-grayP flex gap-1">
                        Fecha límite de pago{" "}
                        <div className="font-bold text-tdark">
                          {creditsInfo?.paydayLimit}
                        </div>
                      </div>
                      <a href="/pagar" className="pt-2">
                        <SecondaryCard text={"Pagar"} />
                      </a>
                    </>
                  ) : (
                    <div className="text-sm text-grayP flex gap-1">
                      No tienes deudas pendientes.
                    </div>
                  )}
                </div>

                <div>
                  <div className="px-4 pt-6">
                    <span className="block text-grayP">Cupo disponible</span>
                    <Numeral
                      className="text-2xl font-bold"
                      format={"$0,0"}
                      value={cupoDisponible}
                    />
                  </div>
                </div>

                <div className="flex gap-2 text-sm pt-6">
                  <div className="grid justify-center w-full">
                    <button
                      type="button"
                      onClick={handleOpenDisclosure}
                      className="bg-purpleLight w-8 h-8 grid content-center justify-center rounded-full mx-auto"
                    >
                      <ArrowTrendingUpIcon className="w-6 h-auto" />
                    </button>
                    Cómo aumentar mi cupo
                  </div>
                </div>

                {cupoDisponible === "0" ||
                  cupoDisponible === 0 ||
                  creditsInfo?.status === "Vigente" ? (
                  <div></div>
                ) : (
                  <>
                    {isOpenSpinner ? (
                      <Spinner
                        sizeSpinner={80}
                        colorSpinner={"#7e02fc"}
                      ></Spinner>
                    ) : (
                      <div className="grid pt-10 justify-center">
                        <a
                          href={"/oferta"}
                          state={{
                            doc: creditsInfo?.documento,
                            name: basicInfo?.firstname
                              ? basicInfo?.firstname
                              : "",
                            amount:
                              creditsInfo.status === "Cancelado"
                                ? 0
                                : creditsInfo.paymentBalance,
                          }}
                          onClick={handleSubmit}
                        >
                          <Primary
                            text={"Solicitar ahora"}
                            icon={<ArrowLongRightIcon className="w-6 h-auto" />}
                          />
                        </a>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        }
      />
    </Fragment>
  );
}
